import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=b5e3914a"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=b5e3914a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports